import { Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { AuthFacade, PetsFacade } from 'auth'
import { AppMenuPanelComponent } from '../app-menu-panel/app-menu-panel.component'
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'ex-app-nav-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, AppMenuPanelComponent],
  templateUrl: './app-nav-menu.component.html',
  styleUrls: ['./app-nav-menu.component.scss']
})
export class AppNavMenuComponent {

  @Input() isOpen = false
  @Output() close = new EventEmitter<void>()

  isAuthenticated = inject(AuthFacade).isAuthenticated
  isAuth$ = inject(AuthFacade).isAuthenticated$

  yummypetsUrl = environment.yummypets

}
